import React from 'react'
import { connect } from 'react-redux'
import {
  withStyles,
  Button,
  Typography,
  Card,
  CardActions
} from '@material-ui/core'
import styles from './styles'
import { compose } from 'recompose'
import Announcement from '@material-ui/icons/Announcement'
import { endEvent } from '../../actions/events'
import moment from 'moment'
import logMaker from '../../lib/logMaker'

const time = (item, ind, arr) => classes => {
  const {
    street_number,
    city,
    route,
    created: createdTime,
    first_name,
    last_name,
    title
  } = item
  const createdTimeFormatted = moment(createdTime).format('h:mma')
  return (
    <div key={ind}>
      {item.mapURL ? (
        <>
          <Card>
            <div className={classes.headerBox}>
              <img
                src={item.mapURL}
                alt="map"
                style={{ width: '100%', height: '100%' }}
              />
            </div>

            <CardActions>
              <div style={{ width: '100%' }}>
                <div className={classes.footerBoxText}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ color: 'secondary', fontWeight: 'bold' }}
                    >
                      {`${
                        first_name ? first_name + ' ' + last_name : 'No client'
                      }`}
                    </Typography>
                    <Typography variant="body2">{`${street_number} ${route}`}</Typography>
                    <Typography variant="body2">{`${city} `}</Typography>
                  </div>
                  <Typography variant="body2" color="secondary">
                    {createdTimeFormatted}
                  </Typography>
                </div>
              </div>
            </CardActions>
          </Card>
          {ind !== arr.length - 1 && (
            <div className={classes.dotWrapper}>
              <div className={classes.small} />
              <div className={classes.small} />
            </div>
          )}
        </>
      ) : (
        <>
          <div className={classes.dotWrapper}>
            <div className={classes.small} />
            <div className={classes.big} />
            <Announcement
              color="secondary"
              style={{ transform: 'translate(0px,1px)' }}
            />
          </div>
          <Card
            className={ind % 2 === 0 ? classes.cardRight : classes.cardLeft}
            style={{ marginBottom: ind === arr.length - 1 ? '0px' : '-24px' }}
          >
            <CardActions>
              <div className={classes.footerBoxTextNotify}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      width: '100%',
                      justifyContent: 'flexStart',
                      alignItems: 'center'
                    }}
                  >
                    <Typography className={classes.notifiedText}>
                      Notified
                    </Typography>
                    <Typography
                      style={{ paddingLeft: '4px', fontSize: '0.7rem' }}
                      color="secondary"
                    >
                      {`${createdTimeFormatted}`}
                    </Typography>
                  </div>
                  <Typography className={classes.personInNotifiedText}>
                    {`${first_name} ${last_name}`}
                  </Typography>
                  <Typography
                    style={{ color: '#aaa', fontSize: '0.8rem' }}
                  >{`${title}`}</Typography>
                </div>
              </div>
            </CardActions>
          </Card>
          {/* Last One Check */}
          {ind !== arr.length - 1 && (
            <div className={classes.dotWrapper}>
              <div className={classes.big} />
              <div className={classes.small} />
              <div className={classes.small} />
              {/* <div className={classes.small} /> */}
            </div>
          )}
        </>
      )}
    </div>
  )
}

class LogPage extends React.Component {
  state = {
    event: {
      city: '',
      created: '',
      creator_id: '',
      route: '',
      start_time: '',
      state: '',
      street_number: '',
      zip: '',
      updated: '',
      id: ''
    },
    eventIndex: ''
  }

  handleEndTimer = () => {
    this.props.dispatch(endEvent(this.props.match.params.event_id))
    this.props.history.push('/')
  }

  render() {
    const { classes, authentication, match } = this.props
    const { authenticatedUser } = authentication
    const { events, connections } = authenticatedUser
    const eventIndex = events.findIndex(x => x.id === +match.params.event_id)
    // event.map(x => {
    //   if (x.id )
    // })
    const event = events[eventIndex]
    const {
      city,
      route,
      street_number,
      creator_id,
      created: createdTime,
      lat,
      lng
    } = event

    const personIndex = connections.findIndex(x => {
      return x.users_id === creator_id
    }) // ! switch to  x.id

    const panicPersonFirstName = connections[personIndex].first_name
    const panicPersonLastName = connections[personIndex].last_name
    const createdTimeFormatted = moment(createdTime).format('h:mm a')
    const zoom = 13
    const windowWidth = window.innerWidth
    const size = `${windowWidth - 30}x80`
    const mapsStaticURL = 'https://maps.googleapis.com/maps/api/staticmap?'
    const mapStyle = `feature:all|element:labels|visibility:simplified&style=feature:all|element:labels.text|color:0x444444&style=feature:administrative.country|element:all|visibility:simplified&style=feature:administrative.country|element:geometry|visibility:simplified&style=feature:administrative.province|element:all|visibility:off&style=feature:administrative.locality|element:all|visibility:simplified|saturation:-100|lightness:30&style=feature:administrative.neighborhood|element:all|visibility:off&style=feature:administrative.land_parcel|element:all|visibility:off&style=feature:landscape|element:all|visibility:simplified|gamma:0.00|lightness:74&style=feature:landscape|element:geometry|color:0xffffff&style=feature:poi|element:all|visibility:off&style=feature:road|element:geometry|visibility:simplified|color:0xff0000|saturation:-15|lightness:40|gamma:1.25&style=feature:road|element:labels|visibility:off&style=feature:transit|element:labels|visibility:simplified&style=feature:transit|element:labels.icon|visibility:off&style=feature:transit.line|element:geometry|color:0xff0000|lightness:80&style=feature:transit.station|element:geometry|color:0xe5e5e5&style=feature:water|element:geometry|color:0xefefef&style=feature:water|element:labels|visibility:off`
    // TODO MAKE COMPONENT FOR LATER
    const mapURL = `${mapsStaticURL}center=${lat},${lng}&zoom=${zoom}&size=${size}&markers=${lat},${lng}&key=${
      process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY
    }&style=${mapStyle}`

    const theLog = logMaker(authenticatedUser, eventIndex)
    return (
      <div className={classes.app}>
        <div className={classes.header} />

        <div className={classes.title}>
          <Typography variant="h6">{`${panicPersonFirstName} ${panicPersonLastName}`}</Typography>
          <Typography style={{ fontSize: '0.9rem' }} color="primary">
            recent check-ins
          </Typography>
        </div>

        <div className={classes.body}>
          <div>
            <div>
              <Card>
                <div className={classes.headerBox}>
                  <img
                    src={mapURL}
                    alt="map"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>

                <CardActions>
                  <div style={{ width: '100%' }}>
                    <div className={classes.footerBoxText}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{ color: 'secondary', fontWeight: 'bold' }}
                        >
                          Showing Started
                        </Typography>
                        <Typography variant="body2">{`${street_number} ${route}`}</Typography>
                        <Typography variant="body2">{`${city} `}</Typography>
                      </div>
                      <Typography variant="body2" color="secondary">
                        {createdTimeFormatted}
                      </Typography>
                    </div>
                  </div>
                </CardActions>
              </Card>
              <div className={classes.dotWrapper}>
                <div className={classes.small} />
                <div className={classes.small} />
              </div>
            </div>

            {theLog.map((item, i, a) => time(item, i, a)(classes))}
          </div>

          <div
            style={{
              width: '80%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              textAlign: 'center',
              marginTop: '20px',
              padding: '50px'
            }}
          >
            <Typography style={{ color: 'secondary', fontWeight: 'bold' }}>
              CLICK HERE TO CHECK IN
            </Typography>

            <Typography
              color="secondary"
              style={{ paddingBottom: '10px', fontWeight: 'bold' }}
            >{`${panicPersonFirstName} ${panicPersonLastName}`}</Typography>

            <Button
              variant="contained"
              onClick={this.handleEndTimer}
              className={classes.footerButton}
              style={{
                color: 'rgba(237,67,106,1)',
                backgroundColor: '#fff',

                margin: '0px auto 20px',
                width: '50%',
                transform: 'scale(1.2)'
              }}
            >
              CHECK IN
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication
  }
}
const mapActionsToProps = dispatch => {
  return {
    toggleDrawer: () => dispatch({ type: 'DRAWER_TOGGLED', payload: true }),
    dispatch
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(LogPage)
